import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UserState } from './user/user.state';

import { Roles } from '@nrwl/rx-models';

export const getUser = createFeatureSelector<UserState>('user');

export const getUserWithLocations = createSelector(getUser, (user) => {
  if (user.value) {
    return {
      ...user.value,
      availableLocations: user.locations,
    };
  }
  return null;
});

export const hasAdminAccess = createSelector(getUser, (user) => {
  if (user.value) {
    if (user.value.role === Roles.SuperAdmin || user.value.role === Roles.Admin) {
      return true;
    }
  }
  return false;
});

export const hasLeadAccess = createSelector(getUser, (user) => {
  if (user.value) {
    if (
      user.value.role === Roles.SuperAdmin ||
      user.value.role === Roles.Admin ||
      user.value.role === Roles.Manager
    ) {
      return true;
    }
  }
  return false;
});

export const isSuperAdmin = createSelector(getUser, (user) => {
  if (user.value) {
    if (user.value.role === Roles.SuperAdmin) {
      return true;
    }
  }
  return false;
});

export const isAdmin = createSelector(getUser, (user) => {
  if (user.value) {
    if (user.value.role === Roles.Admin) {
      return true;
    }
  }
  return false;
});

export const isManager = createSelector(getUser, (user) => {
  if (user.value) {
    if (user.value.role === Roles.Manager) {
      return true;
    }
  }
  return false;
});

export const isEmployee = createSelector(getUser, (user) => {
  if (user.value) {
    if (user.value.role === Roles.Employee) {
      return true;
    }
  }
  return false;
});

export const userRole = createSelector(getUser, (user) => {
  if (user && user.value) {
    return user.value.role;
  }
  return false;
});
